import type { WalletConnector, WalletConnectorType } from '@particle-network/connector-core';
import { useContext } from '../context';
import type { AuthWalletConnectorProperties, EVMWalletConnectorProperties } from '../types/properties';

export const useWalletConnectors = () => {
  const { config } = useContext();

  return config.walletConnectors;
};

export const useWalletConnector = <T extends WalletConnectorType>(
  walletConnectorType: T
): T extends 'particleAuth'
  ? WalletConnector<AuthWalletConnectorProperties>
  : T extends 'evmWallet'
    ? WalletConnector<EVMWalletConnectorProperties>
    : WalletConnector => {
  const walletConnectors = useWalletConnectors();
  return walletConnectors.find((item) => item.type === walletConnectorType) as any;
};
